import React from "react";
import style from './orderCard.module.scss';
import { Link } from "react-router-dom"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";

const ProReportCard = (props) => {

    const calculateLines = text => {
        if (text.length < 88) {
            return text
        } else {
            return text.substr(0, 80) + '...'
        }
    }

    const convertDate = date => {
        let tmpDate = (new Date(date)).toLocaleDateString("fa-IR")
        tmpDate = tmpDate + ' - ' + (new Date(date)).getHours() + ':' + (new Date(date)).getMinutes();

        return tmpDate
    }

    return (
        <div className={`${style.wrapper} ${props.data.commited_count > 0 ? style.yellowBG : style.greenBG}`}>
            <div className={style.newFlexWrapper}>
                <div className={`${props.data.commited_count > 0 ? style.identifierYellow : style.identifierGreen}`}></div>
                <div className={`${style.flexItem} ${style.flexItem303}`}>
                    <div className={style.nameStyle}>
                        <Link
                            className={style.name} style={{ textDecoration: "none" }}
                            to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.dkp}` }}
                            target="_blank"
                        >
                            <div className={style.nameWrapper}>
                                <p
                                    className={style.realName}
                                    data-content={!props.data.title.split(' | ')[1].includes('گارانتی')
                                        &&
                                        !props.data.title.split(' | ')[1].includes('تضمین')
                                        ?
                                        '(' + toPersianNumber(props.data.title.split(' | ')[1]) + ')'
                                        :
                                        ''}
                                >
                                    {calculateLines(toPersianNumber(props.data.title))}
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div className={style.channelPromotion}>
                        <p className={style.channelText}>{props.data.channel.name}</p>
                    </div>
                </div>

                <div className={style.flexItem96}><a href={`https://www.digikala.com/product/dkp-${props.data.dkp}`} className={style.itemLink}>{toPersianNumber(props.data.dkpc)}</a></div>
                <div className={style.flexItem144}>{toPersianNumber(convertDate(props.data.order_item_created_at))}</div>
                <div className={style.flexItem144}>{toPersianNumber(convertDate(props.data.warehouse_status_at))}</div>
                <div className={style.flexItem144}>{toPersianNumber(convertDate(props.data.commitment_date))}</div>
                <div className={style.flexItem96}>{toPersianNumber(props.data.quantity)}</div>
                <div className={style.flexItem96}>{toPersianNumber(props.data.commited_count)}</div>

            </div>

            {props.data.commited_count > 0 && <div className={style.warning}>
                <div className={style.icon}>n</div>
                <p className={style.warningText}>در این سفارش {toPersianNumber(props.data.commited_count)} تنوع دارای تعهد ارسال به انبار دیجی‌کالا وجود دارد</p>
            </div>}
        </div>
    )
}
export default ProReportCard

